export default "$body-font-family: 'Open Sans'\n$alert-font-size: 18px\n\n@import '~vuetify/src/styles/main'\n";